<template>
    <form class="row contact-form" @submit.prevent="submitForm">

        <!-- NAME -->
        <div class="contact-form__field col-12 col-md-6">
            <input 
            v-model="name" 
            placeholder="name" 
            type="text"
            required
            >
        </div>

        <!-- EMAIL -->
        <div class="contact-form__field col-12 col-md-6">
            <input 
            required
            v-model="email" 
            placeholder="email" 
            type="email"
            >
        </div>

        <!-- PHONE -->
        <div class="contact-form__field col-12 col-md-6">
            <input v-model="phone" placeholder="phone" type="text">
        </div>


        <div class="contact-form__field col-12">
            <label for="resume">Resume (optional)</label>
            <input  
            required
            placeholder="cv" 
            type="file" 
            ref="file"
            id="resume"
            @change="uploadFile"
            >
        </div>
        
        <div class="contact-form__field col-12">
            <p>I'm applying as a</p>
            <div class="d-flex flex-column">
                <div 
                class="contact-form__option-holder d-flex  align-items-center"
                :class="{'contact-form__option-holder--active' : applyAs == 'driver'}"
                @click="applyAs = 'driver'"
                >
                    <div class="contact-form__box">
                        <icon-check />
                    </div>
                    <span>Driver</span>
                </div>

                <div 
                class="contact-form__option-holder d-flex  align-items-center"
                :class="{'contact-form__option-holder--active' : applyAs == 'owner'}"
                @click="applyAs = 'owner'"
                >
                    <div class="contact-form__box">
                        <icon-check />
                    </div>
                    <span>Owner</span>
                </div>
            </div>
        </div>



        <div class="contact-form__field col-12">
            <textarea v-model="message" placeholder="Message (optional)"></textarea>
        </div>

        <div class="contact-form__field col-12">
            <button 
            type="submit"
            class="contact-form__button"
            :class="{
                'no-pointer-events opacity-05' : ['success', 'error', 'sending'].includes(requestStatus),
                'cursor-pointer' : ['default'].includes(requestStatus)
            }"
            >
                <template v-if="requestStatus == 'default'">
                    Submit your application
                </template>
                <template v-if="requestStatus == 'sending'">
                    Please wait
                </template>
                <template v-else-if="requestStatus == 'success'">
                    Sent successfully
                </template>
                <template v-else-if="requestStatus == 'error'">
                    An error happened
                </template>
            </button>
        </div>

        <div class="contact-form__field col-12" v-if="['success', 'error'].includes(requestStatus)">
            <p v-if="requestStatus == 'success'">Message sent successfuly. Thank you, we will reply soon.</p>
            <p v-else-if="requestStatus == 'error'">An error happened. please try again.</p>
        </div>




    </form>
</template>


<script>
import IconCheck from './Icons/IconCheck'
import axios from 'axios'

export default {
    components : {
        IconCheck
    },

    props : {
        defaultApplyAs : {
            Type : String,
            required : false,
            default : 'driver'
        }
    },

    data(){
        return {
            name : "",
            email : "",
            phone : "",
            resume : "",
            message : '',
            applyAs : '',

            requestStatus : 'default'
        }
    },

    methods : {
        uploadFile() {
            this.resume = this.$refs.file.files[0];
        },

        submitForm() {
            this.requestStatus = 'sending'


            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('email', this.email);
            formData.append('phone', this.phone);
            formData.append('message', this.message);
            formData.append('resume', this.resume);
            formData.append('apply_as', this.applyAs);
            formData.append('message', this.message);

            const headers = { 'Content-Type': 'multipart/form-data' };
            this.requestStatus = 'sending'

            axios
            .post('/wp-json/wp/v1/new-application', formData, { headers })
            .then((res) => {
                this.requestStatus = 'success'
            })
            .catch(e => {
                this.requestStatus = 'error'
                
                setTimeout(() => {
                    this.requestStatus = 'default'
                }, 4000)
            });


      }
    },

    mounted(){
        this.applyAs = this.defaultApplyAs 
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ContactForm.vue